/* unplugin-vue-components disabled */import { render } from "./FileExcel.vue?vue&type=template&id=135104d6"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__